import { Alert, Button, Image } from '@heroui/react';
import { Edit2 } from 'lucide-react';
import React, { FC } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { useNavigate, useParams } from 'react-router-dom';
import { countryFlagHelper } from 'src/config';

import { ActionBlock, AttractionsList, ContentLoadError, Flex, PageTitle, PageWrapper, Spinner } from '../../../components';
import { useGetOrganization, useQueryHelper } from '../../../queries';
import { HotelDataInformation } from '../components';

export const Organization: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const organizationQuery = useGetOrganization(id);
  const { data, refetch } = organizationQuery;
  const organization = data?.organization;
  const hotel = data?.hotel;
  const { isLoading, isError, errorMessage } = useQueryHelper({
    queries: [organizationQuery],
  });

  if (isLoading) {
    return <Spinner global />;
  }

  if (isError) {
    return (
      <PageWrapper>
        <ContentLoadError onRefreshClicked={() => { refetch(); }} message={errorMessage} />
      </PageWrapper>
    );
  }
  return (
    <div>
      <PageWrapper>
        <PageTitle
          title="Organization City"
          actions={(
            <Button
              variant="solid"
              size="sm"
              color="primary"
              startContent={<Edit2 size={14} color="#fff" />}
              onPress={() => navigate(`/organizations/${id}/edit`)}
            >
              Edit
            </Button>
           )}
        />
        <ActionBlock title={organization?.companyName}>
          <div className="flex h-5 items-center space-x-4 text-small align-center">
            <p className="text-gray-500 flex items-center gap-2 pb-2">
              <strong>ID:</strong>
              {organization?.id}
            </p>
          </div>
          <Flex gap="small" itemAlign="center" justifyContent="flex-start" margin="10px 0">
            {(organization?.languages || []).map((language: string) => {
              const flag = countryFlagHelper(language);
              if (flag.type === 'iso') {
                return (
                  <ReactCountryFlag
                    key={flag.value}
                    countryCode={flag.value}
                    svg
                    style={{ width: 20, height: 20, marginRight: 10 }}
                  />
                );
              }
              return (
                <Image
                  radius="none"
                  classNames={{ wrapper: 'mr-2 inline-block' }}
                  key={flag.value}
                  src={flag.value}
                  alt={flag.value}
                  width={20}
                  height={20}
                />
              );
            })}
            {!organization?.languages && (
            <Alert color="danger" title="No languages detected" />
            )}
          </Flex>
        </ActionBlock>

        <PageTitle title="Hotel" />
        <ActionBlock>
          <HotelDataInformation hotelId={organization?.hotelId || ''} hotel={hotel} />
        </ActionBlock>
        <PageTitle title="Associated Attractions" />
        <AttractionsList attractions={organization?.associated_attractions || []} />

      </PageWrapper>
    </div>
  );
};
